import request from "@/utils/request";

export default function agentChangePwd(params) {
    return request({
        url: `/user/agent/agentChangePwd`,
        method: 'post',
        params
    })
}
